import React from "react";
import SvgMapper from "./SvgMapper";
import "./Style.css";

const IconButton = ({
  label,
  icon, 
  customIcon,
  onClick,
  color = "blue",
  disabled = false,
  className = "",
}) => {
  const IconElement = customIcon
    ? React.createElement(customIcon)
    : icon && SvgMapper[icon]
    ? SvgMapper[icon]("w-4 h-4")
    : null;

  const colorClass = color.replace(/-600|-700|-400|-500|-300/g, '');
  const buttonColorClass = `icon-button-${colorClass}`;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`icon-button ${buttonColorClass} cursor-pointer ${className}`}
    >
      {IconElement}
      <span>{label}</span>
    </button>
  );
};

export default IconButton;
